"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const emotion_1 = require("emotion");
const memoize_one_1 = __importDefault(require("memoize-one"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importStar(require("react"));
const Pagination_1 = __importDefault(require("../Pagination"));
const Select_1 = __importDefault(require("../Select"));
const TextField_1 = __importDefault(require("../TextField"));
class TablePagination extends react_1.PureComponent {
    constructor() {
        super(...arguments);
        this.state = {
            goToPage: '',
        };
        this.onPageChange = ({ selected }) => {
            this.props.onPageChange(selected);
        };
        this.onPageSizeChange = e => {
            e && this.props.onPageSizeChange(e.value);
        };
        this.onGoToPageChange = e => {
            this.setState({ goToPage: e.target.value });
        };
        this.onGoToPageSubmit = e => {
            if (e.key === 'Enter') {
                const parsedPage = parseInt(this.state.goToPage, 10);
                if (!Number.isNaN(parsedPage)) {
                    this.props.onPageChange(parsedPage - 1);
                }
            }
        };
        this.getPageSizeOptions = memoize_one_1.default(pageSizeOptions => pageSizeOptions.map(pageSize => ({ label: pageSize, value: pageSize })));
        this.getSelectedPageSizeOption = () => ({ label: this.props.pageSize, value: this.props.pageSize });
    }
    render() {
        const { className, page, pages, pageSizeOptions, showPageJump, showPageSizeOptions, goToLabelText, perPageLabelText } = this.props;
        const { goToPage } = this.state;
        if (pages < 1) {
            return null;
        }
        const pageSizeSelect = showPageSizeOptions ? (react_1.default.createElement(Select_1.default, { clearable: false, label: perPageLabelText, options: this.getPageSizeOptions(pageSizeOptions), value: this.getSelectedPageSizeOption(), onChange: this.onPageSizeChange })) : null;
        const pageJumpField = showPageJump ? (react_1.default.createElement(TextField_1.default, { label: goToLabelText, value: goToPage, onChange: this.onGoToPageChange, onKeyDown: this.onGoToPageSubmit })) : null;
        return (react_1.default.createElement("div", { className: emotion_1.cx(className, 'rt-pagination') },
            pageSizeSelect,
            pages > 1 && pageJumpField,
            pages > 1 && react_1.default.createElement(Pagination_1.default, { initialPage: page, forcePage: page, pageCount: pages, onPageChange: this.onPageChange })));
    }
}
exports.default = TablePagination;
TablePagination.propTypes = {
    className: prop_types_1.default.string,
    page: prop_types_1.default.number.isRequired,
    pages: prop_types_1.default.number.isRequired,
    pageSize: prop_types_1.default.number.isRequired,
    pageSizeOptions: prop_types_1.default.arrayOf(prop_types_1.default.number).isRequired,
    showPageJump: prop_types_1.default.bool,
    showPageSizeOptions: prop_types_1.default.bool,
    onPageChange: prop_types_1.default.func.isRequired,
    onPageSizeChange: prop_types_1.default.func.isRequired,
    perPageLabelText: prop_types_1.default.string,
    goToLabelText: prop_types_1.default.string,
};
TablePagination.defaultProps = {
    perPageLabelText: 'Per Page',
    goToLabelText: 'Go To',
};
